import o from"styled-components";const i=o.div`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 40px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:o})=>o};
	border-radius: ${({borderRadius:o})=>o}px;
	box-sizing: border-box;
	height: 100%;
`,e=o.div`
	color: ${({color:o})=>o};
	font-size: 56px;
	font-weight: 500;
	line-height: 110%;
	min-height: 56px;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
	overflow: hidden;
	text-overflow: ellipsis;
`,r=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,t=o.p`
	all: unset;
	color: ${({color:o})=>o};
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%;
	opacity: 0.8;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,l=o.div`
	display: grid;
	place-content: center;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: ${({backgroundColor:o})=>o};

	svg {
		width: 32px;
		height: 32px;

		fill: ${({color:o})=>o};

		path,
		circle {
			fill: ${({color:o})=>o};
		}
	}
`,p=o.div`
	position: relative;
	font-size: 25px;
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		display: block;
		width: 24px;
		height: 9px;
		background-color: rgba(0, 0, 0, 0.15);
		border-radius: 9999px;
		filter: blur(5px);
		top: 100px;
		left: 20%;
	}
`;export{i as CardContainer,r as CardContentContainer,p as CardEmoji,e as CardNumber,t as CardParagraph,l as IconContainer};
